import { render, staticRenderFns } from "./ButtonPrimary.vue?vue&type=template&id=31b199b5&scoped=true&lang=pug"
import script from "./ButtonPrimary.vue?vue&type=script&lang=ts"
export * from "./ButtonPrimary.vue?vue&type=script&lang=ts"
import style0 from "./ButtonPrimary.vue?vue&type=style&index=0&id=31b199b5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b199b5",
  null
  
)

export default component.exports